import React from "react";
import { Skeleton, Box } from "@mui/material";
import "./customCardV1Style.css";

function CustomCardV1({
  miniContainerColor,
  borderColor,
  backgroundColor,
  image,
  text,
  children,
  onClick,
  loading = false,
}) {
  return (
    <div
      className="custom_card_v1_main_container"
      style={{
        backgroundColor,
        border: `1px solid ${borderColor}`,
        cursor: onClick ? "pointer" : "default",
      }}
      onClick={onClick}
    >
      <div
        className="custom_card_v1_sub_container"
        style={{ backgroundColor: miniContainerColor}}
      >
        {/* Image Skeleton */}
        {loading ? (
          <Skeleton
            variant="rectangular"
            width={40}
            height={40}
            sx={{ borderRadius: 1, position:'absolute' }}
          />
        ) : (
          <img src={image} className="card_image" />
        )}

        <div className="custom_card_v1_sub_container_text">
          {/* Text Skeleton */}
          {loading ? (
              <p className="custom_card_v1_sub_text" style={{position:'relative', left:`70px`}}> <Skeleton width="80%" /></p>
             
            
          ) : (
            <p className="custom_card_v1_sub_text">{text}</p>
          )}
        </div>
      </div>

      <div style={{ height: 130, marginTop: 20 }}>
        {/* Content Skeleton */}
        {loading ? (
          <Box>
            <Skeleton height={30} sx={{ mb: 1 }} />
            <Skeleton height={30} sx={{ mb: 1 }} />
            <Skeleton height={30} />
          </Box>
        ) : (
          children
        )}
      </div>
    </div>
  );
}

export default CustomCardV1;
